import { Box, Button, TextField, Typography } from "@mui/material"
import { useContext, useState } from "react"
import { updateQuestion } from "../axios/axiosFunctions";
import { AssessmentContext } from "../contexts/assessments";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';

const QuestionElement = ({text,qId}) => {

    const [editMode, setEditMode] = useState(false);
    const [newQuestion, setNewQuestion] = useState(text);
    const [showIcon, setShowIcon] = useState(false);
    const [saved, setSaved] = useState(true);
    const {refetchAssessments} = useContext(AssessmentContext);

    const handleEditMode = ()=>{
        setEditMode(!editMode);
    }

    const handleChange = (e)=>{
        const {value} = e.target;
        setNewQuestion(value);
    }

    const handleSave = async()=>{
        
        const data={
            text: newQuestion,
        }

        const res = await updateQuestion(qId,data);
        if(!res){
            setSaved(false);
        }

        await refetchAssessments();
        handleEditMode();
        setShowIcon(true);
        setTimeout(() => {
            setShowIcon(false);
            setSaved(true);
        }, 1000);

    }

    return (
    <Box sx={{backgroundColor:"white",padding:"20px",borderRadius:"5px",display:"flex",marginBottom:"10px",justifyContent:"space-between",alignItems:"center"}}>
        {
            editMode && <>
                <TextField onChange={handleChange} fullWidth value={newQuestion} color="primary"/>
                <Button onClick={handleSave} color="secondary"><span className="underline-blue">Save</span></Button>
                <Button onClick={handleEditMode} color="secondary"><span className="underline-blue">Cancel</span></Button>
            </>
        }
        {
            !editMode && <>
                <Typography variant="subtitle1">{text}</Typography>
                <Box display={"flex"} alignItems={"center"}>
                    {
                        showIcon && <>
                        {
                            saved ? <CheckCircleIcon sx={{color:"green"}}/> : <ClearIcon sx={{color:"red"}}/>
                        }
                        </>
                    }
                    <Button onClick={handleEditMode} color="secondary"><span className="underline-blue">Edit</span></Button>
                </Box>
            </>
        }
    </Box>
    )
}

export default QuestionElement